//-----validation forms
function validateEmail(email){
    let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email.match(email_string)){
        return true;
    }else {
        return false;
    }

}
function validatePassword(pw){
    return pw.length > 4;
    // return /[A-Z]/       .test(pw) &&
    //     /[a-z]/       .test(pw) &&
    //     /[0-9]/       .test(pw) &&
    //     /[^A-Za-z0-9]/.test(pw) &&
    //     pw.length > 4;

}
function validateName(name){
    return (/[A-Z]/.test(name) || /[a-z]/.test(name) ) && name.length >= 3;
}
function formValidation() {
    let forms = document.querySelectorAll('.js-form-validation');
    if (!forms.length > 0) {
        return;
    }
    forms.forEach(function (form, i){
        form.addEventListener('submit', function (e){
            e.preventDefault();
        })
        let button = form.querySelector('button[type="submit"]');
        button.addEventListener('click',function (e){
            e.preventDefault();
            let validation = true;
            let requiredFields = form.querySelectorAll('input[required]');
            let requiredName = form.querySelectorAll('input[data-name]');
            let requiredPassword = form.querySelectorAll('input[type="password"]');
            let requiredEmail = form.querySelectorAll('input[type="email"]');

            requiredFields.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.field')){
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = "Can't be blank";
                        }
                    }
                }else{
                    if(field.closest('.field')) {
                        field.closest('.field').classList.remove('error');
                    }
                }
            });

            requiredName.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = 'Can\'t be blank';
                        }
                    }
                }else{
                    if (validateName(field.value) != true) {
                        validation = false;
                        if(field.closest('.field')){
                            field.closest('.field').classList.add('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid ' + field.placeholder;
                            }
                        }
                    }else {
                        if(field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid email';
                            }
                        }
                    }
                }
            });
            requiredPassword.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = 'Can\'t be blank';
                        }
                    }
                }else {
                    if (validatePassword(field.value) != true) {
                        validation = false;
                        if(field.closest('.field')){
                            field.closest('.field').classList.add('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Password must be more than 4 characters.';
                            }
                        }
                    }else {
                        if(field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid email';
                            }
                        }
                    }
                }
            });

            requiredEmail.forEach(function (field) {
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if (field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if (field.closest('.field').querySelector('.error-text')) {
                            field.closest('.field').querySelector('.error-text').textContent = 'Can\'t be blank';
                        }
                    } else if (field.closest('#contact_form')) {
                        field.closest('#contact_form').querySelector('.help-text').style.opacity = '1';
                        field.closest('#contact_form').querySelector('.help-text').textContent = 'Can\'t be blank';
                    }
                } else {
                    if (validateEmail(field.value) != true) {
                        validation = false;
                        if (field.closest('.field')) {
                            field.closest('.field').classList.add('error');
                            if (field.closest('.field').querySelector('.error-text')) {
                                field.closest('.field').querySelector('.error-text').textContent = 'Invalid email';
                            }
                        } else if (field.closest('#contact_form')) {
                            field.closest('#contact_form').querySelector('.help-text').style.opacity = '1';
                            field.closest('#contact_form').querySelector('.help-text').textContent = 'Invalid email';
                        }
                    } else {
                        if (field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                        } else if (field.closest('#contact_form')) {
                            field.closest('#contact_form').querySelector('.help-text').style.opacity = '0';
                        }
                    }
                }
            });
            if (validation) {
                form.submit();
                return form;
            }
        })
    });
}
formValidation();

function validateInputs() {
    document.querySelectorAll('.js-form-validation input:not([name="address[default]"])').forEach(function (item){
        item.addEventListener('change', function (e){
            var validation = false;
            if(e.target.hasAttribute('required')){
                let field = e.target;
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.field')){
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = "Can't be blank";
                        }
                    }
                }else{
                    if(field.closest('.field')) {
                        field.closest('.field').classList.remove('error');
                    }
                }
            }else if(e.target.getAttribute('type') == 'email'){
                let field = e.target;
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    if (field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if (field.closest('.field').querySelector('.error-text')) {
                            field.closest('.field').querySelector('.error-text').textContent = 'Can\'t be blank';
                        }
                    } else if (field.closest('#contact_form')) {
                        field.closest('#contact_form').querySelector('.help-text').style.opacity = '1';
                        field.closest('#contact_form').querySelector('.help-text').textContent = 'Can\'t be blank';
                    }
                } else {
                    if (validateEmail(field.value) != true) {
                        validation = false;
                        if (field.closest('.field')) {
                            field.closest('.field').classList.add('error');
                            if (field.closest('.field').querySelector('.error-text')) {
                                field.closest('.field').querySelector('.error-text').textContent = 'Invalid email';
                            }
                        } else if (field.closest('#contact_form')) {
                            field.closest('#contact_form').querySelector('.help-text').style.opacity = '1';
                            field.closest('#contact_form').querySelector('.help-text').textContent = 'Invalid email';
                        }
                    } else {
                        if (field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                        } else if (field.closest('#contact_form')) {
                            field.closest('#contact_form').querySelector('.help-text').style.opacity = '0';
                        }
                    }
                }
            }else if(e.target.hasAttribute('data-name')){
                let field = e.target;
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    if(field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = 'Can\'t be blank';
                        }
                    }
                }else{
                    if (validateName(field.value) != true) {
                        validation = false;
                        if(field.closest('.field')){
                            field.closest('.field').classList.add('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid ' + field.placeholder;
                            }
                        }
                    }else {
                        if(field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid email';
                            }
                        }
                    }
                }
            }else if(e.target.getAttribute('type') == 'password'){
                let field = e.target;
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    if(field.closest('.field')) {
                        field.closest('.field').classList.add('error');
                        if(field.closest('.field').querySelector('.error-valid')){
                            field.closest('.field').querySelector('.error-valid').textContent = 'Can\'t be blank';
                        }
                    }
                }else {
                    if (validatePassword(field.value) != true) {
                        validation = false;
                        if(field.closest('.field')){
                            field.closest('.field').classList.add('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Password must be more than 4 characters.';
                            }
                        }
                    }else {
                        if(field.closest('.field')) {
                            field.closest('.field').classList.remove('error');
                            if(field.closest('.field').querySelector('.error-valid')){
                                field.closest('.field').querySelector('.error-valid').textContent = 'Invalid email';
                            }
                        }
                    }
                }
            }
        })
    })
}
validateInputs();

//-----validation forms end

